export default __webpack_public_path__ + "static/michael-azerhad-formateur-tdd-5e9c9aaab6bb1765be9f05b4bbfe11c4.jpeg";